import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import CenterCreatePage from './center-create'
import CenterEventDetailsPage from './center-details/center-event/center-event-details'
import CenterListPage from './center-list'
import CenterUpdatePage from './center-update'
import { CentersEventListPage } from './centers-event-list'
import EnrollmentProfile from './enrollment-profile/enrollment-profile'

const centerRoutes: Route[] = [
  {
    path: Paths.CENTER_LIST_PAGE,
    element: <CenterListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.CREATE_CENTER_PAGE,
    element: <CenterCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.CENTER_DETAILS_PAGE,
    element: <CenterUpdatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.CENTER_EVENT_LIST_PAGE,
    element: <CentersEventListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.CENTER_EVENT_DETAILS_PAGE,
    element: <CenterEventDetailsPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.ENROLLMENT_PROFILE_PAGE,
    element: <EnrollmentProfile />,
    roles: [RoleEnum.ADMIN]
  }
]

export default centerRoutes
